export const dateWithoutTime = function (date) {
    return date ? date.split('T')[0].split('-').reverse().join('.') : ''
}

export const stringToDate = function (date){
    const [datePart, timePart] = date.split(', ');
    const [day, month, year] = datePart.split('.');
    const [hours, minutes, seconds] = timePart.split(':');

    return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}`);
}

export const convertToLocalTime = function (date) {

    const utcDate = new Date(date)

    // const offsetMinutes = new Date().getTimezoneOffset();
    //
    // const localDate = new Date(utcDate.getTime() - (offsetMinutes * 60 * 1000));
    // console.log(date, localDate)

    return utcDate.toLocaleString();

}

export const dateWithTime = function (date) {
    if (date) {
        const elems = date.split('T');
        const elOne = elems[0].split('-').reverse().join('.');
        const elTwo = elems[1].split('.')[0]; // Исключаем доли секунды
        return elOne + ', ' + elTwo;
    } else {
        return ''
    }
}
export const dateNow = function () {
    const date = new Date()
    const y = date.getFullYear()
    const m = date.getMonth()
    const d = date.getDate()
    // -26 для .toISOString()
    const correctDate = new Date(y, m, d, 26, 59, 59)
    return correctDate.toISOString().split('.').splice(0, 1).join()
}

export const dateOld = function () {
    const date = new Date()
    const y = date.getFullYear()
    const m = date.getMonth() - 2
    const d = date.getDate()
    const oldDate = new Date(y, m, d)
    return new Date(oldDate.getTime() - (oldDate.getTimezoneOffset() * 60000)).toISOString().split('.').splice(0, 1).join()
}